<template>
    <div class="welfare">
        <div class="wrap">
            <img src="https://img.zhangwenpindu.cn/img/banner.png" alt="">
            <Header :isbig="true" @changeLogin="changeLogin"></Header>
        </div>
        <Footer :big="true"></Footer>
        <Login @changeLogin="changeLogin" v-if="isshowlogin"></Login>
    </div>
</template>

<script>
    export default {};
</script>

<style lang="scss" scoped>
    .welfare {
        background: #fff;
        width: 100%;
        min-width: 1600px;

        .wrap {
            position: relative;

            img {
                display: block;
                width: 100%;
                min-height: 600px;
            }
            .header {
                background: transparent;
                position: absolute;
                top: 0;
            }

        }
    }
</style>